/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Day_Short_1Inputs */

const he_statistics_day_short_1 = /** @type {(inputs: Statistics_Day_Short_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ב`)
};

const en_statistics_day_short_1 = /** @type {(inputs: Statistics_Day_Short_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

/**
* | output |
* | --- |
* | "M" |
*
* @param {Statistics_Day_Short_1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_day_short_1 = /** @type {((inputs?: Statistics_Day_Short_1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Day_Short_1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_day_short_1(inputs)
	return en_statistics_day_short_1(inputs)
});